import { MINUTE_MS } from '@/constants/time';
import type { WorkatoAppRawItem } from '../type/workato';

const queryKey = ['apps/workatoConfig'] as const;
type QueryKey = typeof queryKey;

export type workatoAppsConfigQuery = {
  readonly queryKey: QueryKey;
  readonly queryFn: () => Promise<{ items: WorkatoAppRawItem[] }>;
  readonly staleTime: number;
};

/**
 * Fetches UI configurations (icon, description, etc) for the Workato apps.
 */
export function workatoAppsConfigQueryCreator(): workatoAppsConfigQuery {
  return {
    queryKey,
    queryFn: async () => {
      if (!process.env.NEXT_PUBLIC_WORKATO_APP_CONFIG) {
        throw new Error('misconfigured');
      }
      const response = await fetch(process.env.NEXT_PUBLIC_WORKATO_APP_CONFIG);
      const json = (await response.json()) as { items: WorkatoAppRawItem[] };
      return json;
    },
    staleTime: 15 * MINUTE_MS,
  };
}
